<div class="pagination-tile">
  <ng-container *ngIf="showLoader">
    <loader [loading]="collection?.loading$"></loader>
  </ng-container>

  <ng-container *ngIf="collection?.meta?.totalCount > perPageSize && !collection.loadByScrolling && collection.items.length">
    <div class="pagination-list" [class.short-list]="shortList">
      <ng-container *ngIf="collection?.meta && !shortList">
        <span class="pagination-details">
          <span>{{ text | translate: textTranslateParams }}</span>
        </span>
      </ng-container>

      <pagination-tile
        [totalSize]="collection?.meta?.totalCount"
        [perPage]="collection.params.per_page"
        [pageCount]="collection?.meta?.pageCount"
        [maxSize]="3"
        [currentPage]="collection.params.page"
        (selectedPage)="nextPage($event)">
      </pagination-tile>
    </div>
  </ng-container>
</div>
